import axios from 'axios';
// import qs from 'qs';
import { MessageBox, Notification } from 'element-ui';
import NProgress from "nprogress";
import "nprogress/nprogress.css";


// NProgress.configure({
//     showSpinner: false, // Disable the spinner
//     easing: 'ease',
//     speed: 500
// });

// 配置新建一个 axios 实例
const service = axios.create({
    // baseURL: process.env.VUE_APP_API_URL,
    // baseURL: 'http://192.168.1.137:8888', //后端本地
    // baseURL: 'https://ipjava.cn/api', //测试（线上）环境
    // baseURL: '/api/', //生产环境
    baseURL: process.env.VUE_APP_API_URL, //生产环境
    // baseURL: 'https://www.lofeiyu.com/kips/', //测试环境
    // timeout: 2000000,
    // headers: { 'Content-Type': 'application/json' },
});


// 添加请求拦截器
service.interceptors.request.use(
    (config) => {

        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        if (userInfo.role === 'admin') {
            if (localStorage.getItem("adminToken")) {
                config.headers['Authorization'] = `Bearer ${localStorage.getItem('adminToken')}`;
            }
        } else {
            if (localStorage.getItem('token')) {
                config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
            }
        }

        return config;
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
service.interceptors.response.use(
    (response) => {
        const contentType = response.headers['content-type'] || '';
        const isFile =
            contentType.includes('application/octet-stream') ||
            contentType.includes('application/pdf') ||
            contentType.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document') ||
            contentType.includes('application/msword');
        if (isFile) {
            return response;
        }

        const res = response.data;
        if (res.code && res.code !== 200) {
            if (res.code === 403) {
                MessageBox.confirm('登录认证失效，请重新登录!', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    localStorage.clear();
                    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
                    if (userInfo.role === 'admin') {
                        window.location.href = '/memberManagement/memberLogin'; // 管理员登录页
                    } else {
                        window.location.href = '/login'; // 用户登录页
                    }
                })

                return Promise.reject(response);
            } else {
                Notification.error({
                    title: '错误',
                    message: res.message,
                    offset: 100,
                })
                // this.$message.error(res.message);
                return Promise.reject(response);
            }
        }
        return res;
    },
    (error) => {
        // 对响应错误做点什么
        if (error.message.indexOf('timeout') != -1) {
            Notification.error({
                title: '错误',
                message: '网络超时',
                offset: 100,
            })
        } else if (error.message == 'Network Error') {
            Notification.error({
                title: '错误',
                message: '网络连接错误',
                offset: 100,
            })
        } else if (error.response && error.response.status === 500) {
            Notification.error({
                title: '错误',
                message: error.response.data.message || '服务器内部错误',
                offset: 100,
            })
        } else if (error.response && error.response.data.code === 400) {
            Notification.error({
                title: '错误',
                message: error.response.data.message,
                offset: 100,
            })
        } else {
            // Notification.error({
            //     title: '错误',
            //     message: error.response.data.message || '请求出错',
            //     offset: 100,
            // })
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

// 导出 axios 实例
export default service;